var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "DirectBagging"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('legend', [_vm._v("Bagging")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "bagging",
      "id": "bagging",
      "value": "bagging"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "bagging")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "bagging"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "bagging"
    }
  }, [_vm._v("Default")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "directbagging",
      "id": "directbagging",
      "value": "directbagging"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "directbagging")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "directbagging"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "directbagging"
    }
  }, [_vm._v("Direct (Heavies)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "sorterbagging",
      "id": "sorterbagging",
      "value": "sorterbagging"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "sorterbagging")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "sorterbagging"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sorterbagging"
    }
  }, [_vm._v("Sorter Based")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Awb")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter/Scan Awb",
      "name": "shippingId",
      "id": "shippingId"
    },
    domProps: {
      "value": (_vm.shippingid)
    },
    on: {
      "change": _vm.inScan,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingid = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.shippingIdErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shippingIdErrorMSG))]) : _vm._e()], 1), _vm._v(" "), (_vm.showIconInput) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false), [_vm._v(_vm._s(_vm.shipmentColor))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.inScan
    }
  }, [_vm._v("In Scan")]), _vm._v("  \n                      "), _c('button', {
    staticClass: "common-secondary mr-2 btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isInScan) ? _c('div', {
    staticClass: "form-group"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.generateBagNo()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Bag Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagType),
      expression: "bagType"
    }],
    attrs: {
      "type": "text",
      "name": "bagType",
      "readonly": "",
      "id": "bagType"
    },
    domProps: {
      "value": (_vm.bagType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagType = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Destination")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.destination),
      expression: "destination"
    }],
    attrs: {
      "type": "text",
      "name": "destination",
      "readonly": "",
      "id": "destination"
    },
    domProps: {
      "value": (_vm.destination)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.destination = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Generate")])])])])]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.isBagGenerated) ? _c('div', {
    staticClass: "col-lg-5"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPrint
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPrint = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-11"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', {
    staticStyle: {
      "text-align": "left !IMPORTANT",
      "font-size": "20px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Bag No : "), _c('span', {
    staticStyle: {
      "color": "#060607"
    }
  }, [_vm._v(" " + _vm._s(_vm.bagGeneratedData.BagNo))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("AWB No :"), _c('span', {
    staticStyle: {
      "color": "#060607"
    }
  }, [_vm._v(" " + _vm._s(_vm.bagGeneratedData.ShippingID))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Origin : "), _c('span', {
    staticStyle: {
      "color": "#060607"
    }
  }, [_vm._v(" " + _vm._s(_vm.currenthubname))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Destination : "), _c('span', {
    staticStyle: {
      "color": "#060607"
    }
  }, [_vm._v(" " + _vm._s(_vm.destination))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Route : "), _c('span', {
    staticStyle: {
      "color": "#060607"
    }
  }, [_vm._v(" " + _vm._s(_vm.inscanData.routemode))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Group :"), _c('span', {
    staticStyle: {
      "color": "#060607"
    }
  }, [_vm._v(" " + _vm._s(_vm.group))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("PDD :"), _c('span', {
    staticStyle: {
      "color": "#060607"
    }
  }, [_vm._v(" " + _vm._s(_vm.inscanData.pdd))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('b', [_vm._v("Direct Bag :"), _c('span', {
    staticStyle: {
      "color": "#060607"
    }
  }, [_vm._v(" " + _vm._s(_vm.bagGeneratedData.DirectbagLabel))])])])])])])])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending Shipment List"
    },
    model: {
      value: (_vm.showMultipartShipmentModal),
      callback: function($$v) {
        _vm.showMultipartShipmentModal = $$v
      },
      expression: "showMultipartShipmentModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Shipment List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeMutlipartModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Multi Shipment Group Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multipartShipmentDetails), function(data, index) {
    return (_vm.multipartShipmentDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MultiShipmentGroupId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CurrentHubID))])]) : _vm._e()
  }), 0)])])])])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingBag
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingBag = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBagGenerated),
      expression: "isBagGenerated"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v("Bag No")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 no-padding"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNo),
      expression: "bagNo"
    }],
    ref: "bagNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter bag no",
      "disabled": _vm.disabled == 1,
      "name": "bagNo",
      "id": "bagNo",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.bagNo)
    },
    on: {
      "change": function($event) {
        return _vm.validateBag(_vm.bagNo)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNo = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCodeBag, _vm.colorIconBag), false))]), _vm._v(" "), (_vm.bagNoErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagNoErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBagValidated),
      expression: "isBagValidated"
    }],
    staticClass: "col-md-1 text-center"
  }, [_c('label', [_vm._v("Awb")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBagValidated),
      expression: "isBagValidated"
    }],
    staticClass: "col-md-3 no-padding"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scannedAwb),
      expression: "scannedAwb"
    }],
    ref: "scannedAwb",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter/Scan Awb",
      "disabled": _vm.disabled == 1,
      "name": "scannedAwb",
      "id": "scannedAwb",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.scannedAwb)
    },
    on: {
      "change": function($event) {
        return _vm.validateShipment(_vm.scannedAwb)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scannedAwb = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.scannedAwbErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.scannedAwbErrorMSG))]) : _vm._e()], 1), _vm._v(" "), (_vm.isAwbValidated) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary wd-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.closeBag
    }
  }, [_vm._v("Close Bag")]), _vm._v("  \n              ")]) : _vm._e()])], 1)], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb1ce382","hasScoped":true}!./src/views/components/DirectBagging/DirectBagging.html
// module id = 1838
// module chunks = 2